import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import BaseLayout from "../../pages/BaseLayout";
import UsersCreateAgent from "../../pages/Users/UsersCreateAgent";
import UsersDashboard from "../../pages/Users/UsersDashboard";
import UsersListAdmins from "../../pages/Users/UsersListAdmins";
import UsersListAgents from "../../pages/Users/UsersListAgents";
import Private from "../Private";
import UsersCreateAdmin from "./../../pages/Users/UsersCreateAdmin";

function UserRoutes() {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Private>
            <BaseLayout title={t("USERS_1")}>
              <UsersDashboard />
            </BaseLayout>
          </Private>
        }
      />

      <Route
        path="/agents"
        element={
          <Private>
            <BaseLayout title={t("USERS_3")}>
              <UsersListAgents />
            </BaseLayout>
          </Private>
        }
      />

      <Route
        path="/admins"
        element={
          <Private>
            <BaseLayout title={t("USERS_4")}>
              <UsersListAdmins />
            </BaseLayout>
          </Private>
        }
      />

      <Route
        path="/admin/create"
        element={
          <Private>
            <BaseLayout title={t("USERS_8")}>
              <UsersCreateAdmin />
            </BaseLayout>
          </Private>
        }
      />

      <Route
        path="/agent/create"
        element={
          <Private>
            <BaseLayout title={t("USERS_9")}>
              <UsersCreateAgent />
            </BaseLayout>
          </Private>
        }
      />
    </Routes>
  );
}

export default UserRoutes;
